var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('img',{staticClass:"full-width",attrs:{"src":_vm.data.src || _vm.data.guid}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }